import { AxiosInstance } from "../api/AxiosInstance";

export const login = async (credentials) => {
  try {
    const response = await AxiosInstance.post("/api/sec/login", credentials);
    return response.data;
  } catch (error) {
    throw error.response?.data || "login failed";
  }
};

export const singup = async (userdata) => {
  try {
    const response = await AxiosInstance.post("/api/ob/usr/reg", userdata);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Singup failed";
  }
};

export const logout = async (credentials) => {
  try {
    const response = await AxiosInstance.post("/api/auth/logout", credentials)
    return response.data
  } catch (error) {
    throw error.response?.data || "Logout failed";
  }
};

export const getUserSession = async (payload) => {
  try {
    const response = await AxiosInstance.post("/api/auth/getUserSession", payload);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Get user session failed";
  }
};

export const recoverPass = async (credentials) => {
  try {
    const response = await AxiosInstance.post("/api/sec/recopsw", credentials);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Recover pass failed";
  }
};

export const verifyEmail = async (code) => {
  try {
    const response = await AxiosInstance.get(`/api/ob/usr/valida?id=${code}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Verification failed";
  }
};

export const verifyEmailPassRecover = async (code) => {
  try {
    const response = await AxiosInstance.get(`/api/ob/usr/valsolps?id=${code}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Verification failed";
  }
};

export const changePassword = async (credentials) => {
  try {
    const response = await AxiosInstance.post("/api/sec/chp", credentials);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Change pass failed";
  }
};

export const getFirebaseToken = async (payload) => {
  try {
    const response = await AxiosInstance.post("/api/sec/login/externo", payload);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Get Firebase Token failed";
  }
};

// Reenviar correo de confirmación
export const resendVerificationEmail = async (data) => {
  try {
    const response = await AxiosInstance.post("/api/reenviar/correo-confirmacion", data);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Resend verification email failed";
  }
};